(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-options-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.CWM?.contactDialogInitialized) return;
    window.CWM = window.CWM || {};
    window.CWM.contactDialogInitialized = true;

    let contactDialogTrigger = null;

    const getDialog = () => document.querySelector('[data-contact-options-dialog]');

    const openShopifyInbox = (attempt = 0) => {
      const inboxChat = document.querySelector('shopify-chat');
      if (typeof inboxChat?.show === 'function') {
        inboxChat.show();
        return;
      }

      const inboxRoot = inboxChat?.shadowRoot;
      const inboxRuntime = inboxRoot?.querySelector('shopify-agent-runtime');
      const inboxActivator = inboxRoot?.querySelector('[part="activator"]')
        || inboxRuntime?.shadowRoot?.querySelector('[part="activator"]');

      if (inboxActivator) {
        inboxActivator.click();
        return;
      }

      if (attempt < 10) {
        window.setTimeout(() => openShopifyInbox(attempt + 1), 200);
      }
    };

    document.addEventListener('click', event => {
      const openButton = event.target.closest('[data-contact-dialog-open]');
      const closeButton = event.target.closest('[data-contact-dialog-close]');
      const inboxButton = event.target.closest('[data-contact-dialog-inbox]');
      const emailLink = event.target.closest('[data-contact-dialog-email]');
      const dialog = getDialog();

      if (openButton && dialog && typeof dialog.showModal === 'function') {
        contactDialogTrigger = openButton;
        dialog.showModal();
      }

      if (closeButton && dialog?.open) {
        dialog.close();
      }

      if (emailLink && dialog?.open) {
        dialog.close();
      }

      if (inboxButton) {
        if (dialog?.open) dialog.close();
        openShopifyInbox();
      }
    });

    const dialog = getDialog();
    dialog?.addEventListener('click', event => {
      if (event.target === dialog) dialog.close();
    });

    dialog?.addEventListener('close', () => {
      contactDialogTrigger?.focus();
      contactDialogTrigger = null;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
